
export default {
    props:['elements','maxWidth'],
    name:'hyperCoreSpacer'
}
